import { Typography } from 'antd';

const { Text } = Typography;

/** One setting on the Help Desk tab: its title, the control, and a note under it. */
export const HelpDeskRow: React.FC<{
  title: string;
  note: React.ReactNode;
  testId: string;
  children: React.ReactNode;
}> = ({ title, note, testId, children }) => (
  <div data-testid={testId}>
    <Text strong>{title}</Text>
    <div style={{ marginTop: 4 }}>{children}</div>
    <Text type="secondary">{note}</Text>
  </div>
);
